import Modal from 'modules/Modal';

export default (function() {

	function init(link, modal, form) {
		Modal.init(link, modal);

		form.find('p.stars a').hover((e) => {
			$(e.currentTarget).closest('p.stars').toggleClass('is-hover');
		});

		$('.js-reviews-close').click(e => {
			e.preventDefault();
			$(modal).modal('hide');
		});
	}

	return {
		init
	};
})();